import React from 'react';
import moment from 'moment';
import Box from '@bit/knotchinc.web-react-components.box';
import Text from '@bit/knotchinc.web-react-components.text';
import { Title } from 'components/Global/StatCard/styled.js';
import { numberWithCommas } from 'helpers/Utils.js';
import MultiLine from 'components/Graphs/MultiLine/MultiLine.jsx';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import upwardTrend from 'images/icons/upwardTrend.svg';
import { TimeFilter, Timestamp } from './styled';

const API_DATE_FORMAT = 'YYYY-MM-DD';
const ContentPieceCount = ({ count }) =>
  <Text
    display="inline-block"
    color="white"
    fontWeight="300"
    fontSize="24px"
    marginRight="8px"
  >
    {numberWithCommas(count)}
  </Text>;

class ContentOverTime extends React.Component {
  render() {
    const {
      store,
      showFilters,
      storeFetch,
      setFilters,
     } = this.props;

    const { data, filters } = store;
    const { num_total_contents, contents_over_time } = data;

    let timeFilters = null;
    if (showFilters && filters) {
      timeFilters = [90, 120, 365].map((time) => {
        const startDate = moment().subtract(time, 'day').format(API_DATE_FORMAT);
        return (<TimeFilter
          key={`content_over_time_${time}`}
          selected={filters.start_date && startDate === filters.start_date}
          onClick={() => setFilters({ start_date: startDate, end_date: moment().format(API_DATE_FORMAT) })}
        >
          {`${time} Days`}
        </TimeFilter>);
      });
    }

    return (
      <React.Fragment>
        <Box mb="10px">
          <Title titleIcon={upwardTrend}>Content Over Time</Title>
          {timeFilters}
        </Box>
        <StoreSync stores={{ contentOverTime: store }} fetchMap={{ contentOverTime: () => storeFetch() }}>
          <React.Fragment>
            <MultiLine data={contents_over_time} xaxis="date" height="130px" />
            <Box width="95%" position="relative">
              <Timestamp>{moment(filters.start_date).format('MM-YYYY')}</Timestamp>
              <Timestamp right={0}>{moment(filters.end_date).format('MM-YYYY')}</Timestamp>
            </Box>
            {num_total_contents && num_total_contents > 0 ?
              <Box pt="18px">
                <ContentPieceCount count={num_total_contents} />
                <Text display="inline-block" fontSize="14px" letterSpacing="0.02em" color="#2D8BFF">Content Pieces</Text>
              </Box> : null
            }
          </React.Fragment>
        </StoreSync>
      </React.Fragment>);
  }
}

export default ContentOverTime;
